export default {
    ASYNC_MODAL_DATE_IS_OPEN: "ASYNC_MODAL_DATE_IS_OPEN",
    MODAL_DATE_IS_OPEN: "MODAL_DATE_IS_OPEN",
    ASYNC_OPEN_MODAL_DATE: "ASYNC_OPEN_MODAL_DATE",
    
    CHANGE_MENU_MANAGER_ACTIVE: "CHANGE_MENU_MANAGER_ACTIVE",
    CHANGE_TAB_COUPON_ACTIVE: "CHANGE_TAB_COUPON_ACTIVE"
};
  